import { openNewWindow, twitterShareUrl } from '../../utils';
import RoundButton from '../../components/round-button/RoundButton';
import styles from './shareInProject.module.less';
import RoundedImage from '../../components/RoundedImage';

const TwitterShareButton = ({
    urlToShare,
    trackEventName,
    trackEventFunction,
    buttonClassName,
    horizontal,
    logoAsButton,
}) => {
    const twitterUrl = twitterShareUrl(encodeURI(urlToShare));

    return (
        <div className={[styles.shareComponent, horizontal ? styles.horizontal : ''].join(' ')}>
            <RoundButton
                onClick={() => {
                    trackEventFunction();
                    openNewWindow(twitterUrl);
                }}
                className={buttonClassName}
                category={trackEventName}
                action="twitter"
                alt="Del på Twitter"
                label={urlToShare}
            >
                {logoAsButton ? (
                    <RoundedImage className={styles.logo} src="X_logo.jpg" size={'48px'} />
                ) : (
                    <i className="fab fa-x-twitter" title="Del på X">
                        <span className="sr-only">Del på X</span>
                    </i>
                )}
            </RoundButton>
            <div className={styles.shareDescription}>X</div>
        </div>
    );
};

export default TwitterShareButton;
